module.exports = __webpack_public_path__ + "media/images/front/badge_shop-5bc2432e25bc8a395de64fb3cd41f817.png";